<!-- ========== Left Sidebar Start ========== -->
<app-side-menu (sideNavMessage$)="listenerNav($event)"
[language]="language"></app-side-menu>
<!-- Left Sidebar End -->
<!-- Navbar Start -->
<app-nav-bar (navMessage$)="listenerNav($event)"></app-nav-bar>
<!-- end Navbar -->
<!-- Footer Start -->
<app-footer></app-footer>
<!-- end Footer -->
<!-- body -->
@if (!loading && security.permitted('inventory', 'inventory detail', 'view')) {
  <div class="content-page bg-gray">
    <div class="content text-dark">
      <div class="d-flex align-items-center col-md-12 col-sm-12">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb text-capitalize text-dark h5">
            <li class="breadcrumb-item"><a [routerLink]="['/inventory']"
            class="text-secondary">{{words[language][ 'Inventory' ] }}</a>
          </li>
          <li class="breadcrumb-item text-secondary" aria-current="page">{{words[language][ 'detail' ] }}</li>
          <li class="breadcrumb-item text-dark" aria-current="page">{{words[language][ 'stock' ] }} #:
          {{stockNumber}}</li>
        </ol>
      </nav>
      <div class="ml-auto align-items-center">
        @if (detailInfo) {
          <div>
            @if (detailInfo.createdBy !== null) {
              <small class="text-dark font-weight-bold mr-1"
              >{{words[language][ 'createdBy' ] }}:</small>
            }
            @if (detailInfo.createdBy !== null) {
              <small class="text-dark mr-3">{{detailInfo.createdBy}}</small>
            }
            @if (detailInfo.createdAt !== null) {
              <small class="text-dark font-weight-bold mr-1"
              >{{words[language][ 'createdAt' ] }}:</small>
            }
            @if (detailInfo.createdAt !== null) {
              <small class="text-dark mr-3">{{detailInfo.createdAt
              | date:'short'}}</small>
            }
            @if (detailInfo.modifiedBy !== null) {
              <small class="text-dark font-weight-bold mr-1"
              >{{words[language][ 'modifiedBy' ] }}:</small>
            }
            @if (detailInfo.modifiedBy !== null) {
              <small class="text-dark mr-3"
              >{{detailInfo.modifiedBy}}</small>
            }
            @if (detailInfo.modifiedBy !== null) {
              <small class="text-dark font-weight-bold mr-1"
              >{{words[language][ 'dateModified' ] }}:</small>
            }
            @if (detailInfo.modifiedBy !== null) {
              <small class="text-dark mr-3">{{detailInfo.updatedAt |
              date:'short'}}</small>
            }
          </div>
        }
      </div>
    </div>
    @if (inventoryId > 0) {
      <section class="sticky-toolbar rounded">
        <div class="card">
          <div title="Show Alerts & Notes">
            <notes [module]="'inventory'" [inventoryId]="inventoryId" title="Show Alerts & Notes" (notes$)="listenerChildrens($event)"></notes>
          </div>
        </div>
      </section>
    }
    <!-- <div> -->
    <!-- section general information -->
    <section class="col-md-12 col-sm-12">
      <inventory-general-information (emitterInformation$)="listenerChildrens($event)" [language]="language" [fileURL]="fileURL"
        [reconCostTotal]="reconCostTotal" [inventoryId]="inventoryId" [floorPlanCostTotal]="floorPlanCostTotal">
      </inventory-general-information>
    </section>
    <section class="col-md-12 col-sm-12">
      <inventory-reconditioning-cost (emitterInformation$)="listenerChildrens($event)" [language]="language"
        [inventoryId]="inventoryId">
      </inventory-reconditioning-cost>
    </section>
    <section class="col-md-12 col-sm-12">
      <inventory-floor-plans (emitterInformation$)="listenerChildrens($event)" [language]="language"
        [inventoryId]="inventoryId" [dateOnLot]="dateOnLot" [purchaseCost]="purchaseCost">
      </inventory-floor-plans>
    </section>
    <section class="col-md-12 col-sm-12">
      <inventory-images-list (emitterInformation$)="listenerChildrens($event)" [language]="language"
      [inventoryId]="inventoryId"></inventory-images-list>
    </section>
    <section class="col-md-12 col-sm-12">
      <inventory-print-center (emitterInformation$)="listenerChildrens($event)" [language]="language"
      [inventoryId]="inventoryId"></inventory-print-center>
    </section>
    <section class="col-md-12 col-sm-12">
      <!-- <gps-inventory-assignment (emitterInformation$)="listenerChildrens($event)" [vehicleId]="vehicleId"></gps-inventory-assignment> -->
    </section>
    @if (loading) {
      <div class="content-page bg-gray d-flex justify-content-center align-items-center">
        <div class="spinner-grow avatar-lg text-secondary" role="status"></div>
      </div>
    }
  </div>
</div>
}